"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CacheInterface = /** @class */ (function () {
    function CacheInterface() {
        this.cache = {};
    }
    /**
     * Sets a value on the cache.
     * @param key
     * @param value
     * @param expires
     */
    CacheInterface.prototype.set = function (key, value, expires) {
        if (expires === void 0) { expires = null; }
        var date = null;
        if (expires !== null) {
            date = new Date(Date.now() + expires);
        }
        this.cache[key] = {
            value: value,
            expires: date
        };
    };
    /**
     * Gets a value from the cache if it exists, if not returns a fallback
     * @param key
     * @param fallback
     * @returns {*}
     */
    CacheInterface.prototype.get = function (key, fallback) {
        if (fallback === void 0) { fallback = null; }
        if (this.has(key)) {
            var node = this.cache[key];
            if (this.isValid(node)) {
                return node.value;
            }
        }
        return fallback;
    };
    /**
     * Checks if a cache value is valid
     * @param node
     * @returns {boolean}
     * @private
     */
    CacheInterface.prototype.isValid = function (node) {
        if (node.expires !== null) {
            if (new Date() > node.expires) {
                return false;
            }
        }
        return true;
    };
    /**
     * Check if the cache contains this value
     * @param value
     * @returns {boolean}
     */
    CacheInterface.prototype.contains = function (value) {
        for (var i in Object.keys(this.cache)) {
            if (this.cache[i].value === value) {
                return true;
            }
        }
        return false;
    };
    /**
     * Checks if the cache has a specific key
     * @param key
     * @returns {boolean}
     */
    CacheInterface.prototype.has = function (key) {
        return this.cache.hasOwnProperty(key);
    };
    /**
     * Returns all of the items in the cache
     * @returns Object
     */
    CacheInterface.prototype.all = function () {
        var out = [];
        for (var i in Object.keys(this.cache)) {
            if (this.cache.hasOwnProperty(i)) {
                out.push(this.cache[i].value);
            }
        }
        return out;
    };
    /**
     * Remove a value from the cache if it exists.
     * @param key
     */
    CacheInterface.prototype.remove = function (key) {
        if (this.has(key)) {
            delete this.cache[key];
        }
    };
    return CacheInterface;
}());
exports.CacheInterface = CacheInterface;
//# sourceMappingURL=data:application/json;base64,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